var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"PopupWindow",class:{ 'PopWdshow': _vm.dialogInfo.visible },attrs:{"id":"editUser_PopWd"}},[_vm._t("default")],2),_c('div',{class:{ 'blockshow': _vm.dialogInfo.visible },attrs:{"id":"blockOverlay"}})])}
var staticRenderFns = []

export { render, staticRenderFns }